import * as React from 'react';

import { CartServiceProps } from '../../types';
import { ServiceSummary } from '../../../features/service-summary';

const PriorityBoarding: React.FC<CartServiceProps> = ({ onServiceDelete }) => {
	return (
		<ServiceSummary serviceType="PriorityBoarding" onDelete={onServiceDelete}>
			{children => children && <span>{children}</span>}
		</ServiceSummary>
	);
};

export default PriorityBoarding;
